import Link from 'next/link'

export default function SiteFooter() {
  const year = new Date().getFullYear()

  return (
    <footer className="mt-24 bg-gray-50 text-gray-900 dark:bg-black dark:text-white border-t border-gray-200 dark:border-white/10">
      {/* Top CTA */}
      <div className="container py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <p className="text-2xl font-semibold">Start replying to reviews in minutes.</p>
          <p className="text-sm opacity-80 mt-1">No credit card needed, free plan included.</p>
        </div>
        <Link href="/signup" className="btn-primary rounded-xl px-5 py-2.5">
          Get started free
        </Link>
      </div>

      {/* Social proof strip */}
      <div className="border-t border-gray-200 dark:border-white/10">
        <div className="container py-4 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs md:text-sm">
          <div className="flex items-center gap-2">
            <span className="text-amber-500 text-base leading-none">★★★★★</span>
            <span className="opacity-80">
              Loved by local clinics, preschools, salons, and agencies.
            </span>
          </div>
          <div className="flex flex-wrap items-center gap-3 opacity-80">
            <span className="inline-flex items-center gap-1">
              <span className="h-2 w-2 rounded-full bg-emerald-500" />
              <span>Secure payments via Razorpay &amp; PayPal</span>
            </span>
            <span className="hidden md:inline-block h-4 w-px bg-gray-300 dark:bg-white/20" />
            <span>Data hosted safely with Supabase &amp; Google APIs</span>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="border-t border-gray-200 dark:border-white/10">
        <div className="container py-12 grid gap-10 md:grid-cols-4">
          {/* Brand */}
          <div>
            <Link href="/" className="font-semibold text-lg">
              <span className="inline-flex items-center gap-2">
                <span className="font-semibold tracking-wide">
                  <span className="h2 text-gray-900 dark:text-white">ping</span>
                  <span className="h2 text-blue-600">replies</span>
                </span>
                                  <span className="text-[10px] uppercase text-white-700"> beta </span>

              </span>
            </Link>
            <p className="text-sm text-gray-600 dark:text-white/70 mt-2">
              AI-powered replies for your Google reviews.
            </p>
          </div>

          {/* Product links */}
          <div>
            <p className="font-medium mb-3">Product</p>
            <ul className="space-y-2 text-sm text-gray-700 dark:text-white/80">
              <li><Link href="/#features" className="hover:text-blue-600 dark:hover:text-blue-400">Features</Link></li>
              <li><Link href="/#pricing" className="hover:text-blue-600 dark:hover:text-blue-400">Pricing</Link></li>
              <li><Link href="/#testimonials" className="hover:text-blue-600 dark:hover:text-blue-400">Testimonials</Link></li>
              <li><Link href="/#faq" className="hover:text-blue-600 dark:hover:text-blue-400">FAQ</Link></li>
            </ul>
          </div>

          {/* Company links */}
          <div>
            <p className="font-medium mb-3">Company</p>
            <ul className="space-y-2 text-sm text-gray-700 dark:text-white/80">
              <li><Link href="/privacy" className="hover:text-blue-600 dark:hover:text-blue-400">Privacy</Link></li>
              <li><Link href="/terms" className="hover:text-blue-600 dark:hover:text-blue-400">Terms</Link></li>
              <li><Link href="/refund" className="hover:text-blue-600 dark:hover:text-blue-400">Refund Policy</Link></li>
              <li><Link href="/contact" className="hover:text-blue-600 dark:hover:text-blue-400">Contact</Link></li>
            </ul>
          </div>

          {/* Contact + Social */}
          <div>
            <p className="font-medium mb-3">Contact</p>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  className="hover:text-blue-600 dark:hover:text-blue-400"
                  href="mailto:contact@pingreplies.com"
                >
                  contact@pingreplies.com
                </a>
              </li>
              <li>
                <a
                  className="hover:text-blue-600 dark:hover:text-blue-400"
                  href="tel:+919884732100"
                >
                  +91 98847 32100
                </a>
              </li>
              <li className="text-gray-600 dark:text-white/70">
                Mon–Fri • 9:00–18:00 IST
              </li>
              <li className="text-xs text-gray-500 dark:text-white/60 mt-2">
                Supporting teams across India, US &amp; UAE.
              </li>

              {/* Social icons row */}
              <li className="pt-3">
                <p className="text-xs uppercase tracking-wide text-gray-500 dark:text-white/60 mb-1">
                  Follow us
                </p>
                <div className="flex items-center gap-3 text-lg">
                  <a
                    href="https://twitter.com/wannaapps"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="hover:text-blue-500 transition"
                    aria-label="PingReplies on X (Twitter)"
                  >
                    <i className="ri-twitter-x-line" />
                  </a>
                  <a
                    href="https://instagram.com/wanna_apps"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="hover:text-pink-500 transition"
                    aria-label="PingReplies on Instagram"
                  >
                    <i className="ri-instagram-line" />
                  </a>
                  <a
                    href="https://facebook.com/wannaapps"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="hover:text-blue-600 transition"
                    aria-label="PingReplies on Facebook"
                  >
                    <i className="ri-facebook-circle-line" />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/wannaapps/"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="hover:text-blue-700 transition"
                    aria-label="PingReplies on LinkedIn"
                  >
                    <i className="ri-linkedin-box-line" />
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-200 dark:border-white/10">
        <div className="container py-5 text-xs text-gray-600 dark:text-white/70 flex flex-col md:flex-row items-center justify-between gap-2">
          <span>
            © {year} PingReplies — Fueled by{' '}
            <a
              href="https://wannaapps.com"
              target="_blank"
              rel="noreferrer noopener"
              className="hover:text-blue-600 dark:hover:text-blue-400"
            >
              Wannaapps Technologies
            </a>
          </span>

          <div className="flex items-center gap-3">
            <span className="opacity-80 hidden sm:inline">Made with ❤️ for local businesses</span>
            {/* Tiny social echo in bottom bar (optional) */}
            <div className="flex items-center gap-2 text-lg sm:text-base">
              <a
                href="https://twitter.com/wannaapps"
                target="_blank"
                rel="noreferrer noopener"
                className="hover:text-blue-500 transition"
                aria-label="PingReplies on X (Twitter)"
              >
                <i className="ri-twitter-x-line" />
              </a>
              <a
                href="https://www.linkedin.com/company/wannaapps/"
                target="_blank"
                rel="noreferrer noopener"
                className="hover:text-blue-700 transition"
                aria-label="PingReplies on LinkedIn"
              >
                <i className="ri-linkedin-box-line" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
